"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatQuillOutput = void 0;
var html_to_text_1 = require("html-to-text");
var formatQuillOutput = function (html) {
    return (0, html_to_text_1.htmlToText)(html, {
        wordwrap: 130, // Устанавливает ширину строки
        selectors: [
            // Обработка заголовков
            { selector: "h1", format: "heading", options: { uppercase: false } },
            { selector: "h2", format: "heading", options: { uppercase: false } },
            { selector: "h3", format: "heading", options: { uppercase: false } },
            // Обработка параграфов
            { selector: "p", format: "inline" },
            // Обработка ссылок
            {
                selector: "a",
                options: {
                    hideLinkHrefIfSameAsText: true,
                    ignoreHref: false,
                },
            },
            // Обработка списков
            { selector: "ul", format: "list" },
            { selector: "ol", format: "list" },
        ],
        preserveNewlines: true, // Сохраняет разрывы строк
    });
};
exports.formatQuillOutput = formatQuillOutput;
